import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import Etapas from "../../../Components/CardsPages/Etapas";
import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";

import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";

import "../../../Assets/css/pages/placeholder.css";
import Acoes from "../../../Components/CardsPages/Atendimento/Acoes";
import { useUserInfor } from "../../../Context/User";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import AgendamentosDoAtendimento from "../../AssistenciaTecnica/Atendimento/AgendamentosDoAtendimento";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import BlocoAssinaturaEntregaChaves from "../../../Components/CardsPages/BlocoAssinaturaEntregaChaves";
import StatusEtapa from "../../../Components/CardsPages/StatusEtapa";
import KPIVistoriaEntregaDeChaves from "../KPIVistoriaEntregaDeChaves";

interface IRouteParams {
    IDCaso: string;
}
interface IEntregaChavesPageProps {
    IDCaso: number;
}

export default function AtendimentoEntregaChaves() {
    const params = useParams<IRouteParams>();
    const idCaso = Number.parseInt(params.IDCaso);

    return (
        <AtendimentoPageProvider ID_CASO={idCaso}>
            <EntregaChavesPage IDCaso={idCaso} />
        </AtendimentoPageProvider>
    );
}

function EntregaChavesPage(props: IEntregaChavesPageProps) {
    const [bloquearAcoes, setBloquearAcoes] = useState(false);

    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;
    const { UserInfor } = useUserInfor();

    const initialTab = useMemo(
        () => ({
            Component: () => (
                <AgendamentosDoAtendimento
                    Atendimento={Atendimento}
                    idCaso={props.IDCaso}
                />
            ),
            icon: faCalendar,
            key: "#agendamento",
            name: "Agendamentos",
        }),
        [props.IDCaso, Atendimento]
    );

    const extraTabs = useMemo(() => {
        const extraTabs: any[] = [
            /*{
            key: '#casosVinculados',
            name: 'Atendimentos Vinculados',
            icon: faLink,
            Component: () => <AtendimentosVinculados idCaso={Atendimento.ID_CASO} />
        }*/
        ];

        return extraTabs;
    }, []);

    return (
        <>
            {Atendimento ? (
                <>
                    <div className="col-12 mb-5">
                        <Etapas
                            ID_CATEGORIA={0}
                            ID_ETAPA={Atendimento.ID_ETAPA_TIPO_CASO}
                            finalizado={!!Atendimento.DT_FIM}
                        />
                    </div>
                    {
                        <AtendimentoDetalhado
                            IDCaso={props.IDCaso}
                            Atendimento={Atendimento}
                            inicialTab={initialTab}
                            extraTabs={extraTabs}
                            adicionalComponent={
                                Atendimento.ID_ETAPA_TIPO_CASO &&
                                !AtendimentoPage.bloquearInteracoes &&
                                (Atendimento.ID_USUARIO_RESPONSAVEL ===
                                    UserInfor.ID_USUARIO ||
                                    UserInfor.FUNCOES.some(
                                        (f) =>
                                            f.NM_FUNCAO ===
                                            "ADM_PERMITE_ACOES_TELA_ATENDIMENTO"
                                    )) ? (
                                    <>
                                        <Acoes
                                            ID_ETAPA={
                                                Atendimento.ID_ETAPA_TIPO_CASO
                                            }
                                            ID_CASO={Atendimento.ID_CASO}
                                            bloquearAcoes={bloquearAcoes}
                                        />
                                        <StatusEtapa
                                            idEtapaTipoCaso={
                                                Atendimento.ID_ETAPA_TIPO_CASO
                                            }
                                            setBloquearAcoes={setBloquearAcoes}
                                            idCaso={props.IDCaso}
                                        />

                                        <BlocoAssinaturaEntregaChaves
                                            idCaso={props.IDCaso}
                                        />
                                    </>
                                ) : undefined
                            }
                            KPICard={() => (
                                <KPIVistoriaEntregaDeChaves
                                    DT_SLA={Atendimento.DT_SLA}
                                />
                            )}
                            buttons={<></>}
                        />
                    }
                </>
            ) : (
                <div className="text-muted text-center">
                    Atendimento não encontrado
                </div>
            )}
        </>
    );
}
